




































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

@Component({})
export default class RoutingModal extends Vue {
  private eventEmit = {
    eventCloseModal: 'eventCloseModal'
  };

  @Prop({default: false})
  private isShowModal!: boolean;

  @Prop({default: null})
  private data!: any;

  private async created() {
    document.documentElement.style.overflow = 'hidden';
  }

  private onClose() {
      document.documentElement.style.overflow = 'auto';
      this.$emit(this.eventEmit.eventCloseModal, {
        data: null,
        close: true
      });
  }
}
